import { motion } from "framer-motion";

const animationConfiguration = {
  initial: { x: "20%", opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: "-20%", opacity: 0, transition: { duration: 0.25 } },
};
const Transition = ({ initial = "initial", children, exit = "exit", duration = 0.25 }) => {
  return (
    <motion.div variants={animationConfiguration} initial={initial} animate="animate" exit={exit} transition={{ delay: 0, duration: duration }}>
      {children}
    </motion.div>
  );
};
export default Transition;
